<template>
    <div class="dashboard">
        <header-navigation/>
        <div class="container">
            <error ref="error"/>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import HeaderNavigation from '../components/HeaderNavigation.vue';
import BottomCredits from '../components/BottomCredits.vue';
import Error from '../components/Error.vue';

export default {
    components: {
        HeaderNavigation, 
        BottomCredits,
        Error
    },
    mounted: function() {
        var globv = this;
        globv.$refs.error.showError({
            status: 403,
            title: "Forbidden",
            message: "You are forbidden from accessing this resource. Please log in."
        });
    }
}
</script>